import { ACTIONS } from './types';
import STATUS from '../../../globalStatuses';

function higherEds(
  state = {
    higherEds: [],
    higherEdsPersonId: null,
    esignHigherEds: [],
    higherEdsStatus: {
      getStatus: STATUS.UNFETCHED,
      modifyStatus: STATUS.UNFETCHED,
      errorData: null,
    },
    esignHigherEdsStatus: {
      getStatus: STATUS.UNFETCHED,
      modifyStatus: STATUS.UNFETCHED,
      errorData: null,
    },
  },
  action,
) {
  switch (action.type) {
    // GET Higher Ed
    case ACTIONS.REQUEST_HIGHER_ED:
      return {
        ...state,
        higherEdsPersonId: action.personId,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
        higherEds: null,
      };
    case ACTIONS.RECEIVE_HIGHER_ED:
      if (state.higherEdsPersonId !== action.personId) return state;
      // Add original index for keeping track of schema errors
      return {
        ...state,
        higherEds: action.higherEds.map((ed, index) => (
          {
            ...ed,
            index,
          }
        )),
        higherEdsStatus: {
          ...state.higherEdsStatus,
          getStatus: STATUS.FETCHED,
        },
      };
    case ACTIONS.REQUEST_HIGHER_ED_ERROR:
      if (state.higherEdsPersonId !== action.personId) return state;
      return {
        ...state,
        error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          getStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };
    case ACTIONS.CLEAR_HIGHER_ED_GET_STATUS:
      return {
        ...state,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          getStatus: STATUS.UNFETCHED,
          errorData: null,
        },
      };
    // POST Higher Ed
    case ACTIONS.REQUEST_SAVE_HIGHER_ED:
      return {
        ...state,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          modifyStatus: STATUS.UPDATING,
          errorData: null,
        },
        esignHigherEds: [],
        esignHigherEdsStatus: {
          ...state.esignHigherEdsStatus,
          getStatus: STATUS.UNFETCHED,
        },
      };
    case ACTIONS.RECEIVE_SAVE_HIGHER_ED:
      return {
        ...state,
        higherEds: action.higherEds,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          modifyStatus: STATUS.UPDATED,
        },
      };
    case ACTIONS.REQUEST_SAVE_HIGHER_ED_ERROR:
      return {
        ...state,
        error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          modifyStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };

    // DELETE Higher Ed
    case ACTIONS.REQUEST_DELETE_HIGHER_ED:
      return {
        ...state,
        higherEds: [],
        higherEdsStatus: {
          ...state.higherEdsStatus,
          getStatus: STATUS.UNFETCHED,
          modifyStatus: STATUS.UPDATING,
          errorData: null,
        },
        esignHigherEds: [],
        esignHigherEdsStatus: {
          ...state.esignHigherEdsStatus,
          getStatus: STATUS.UNFETCHED,
        },
      };
    case ACTIONS.RECEIVE_DELETE_HIGHER_ED:
      return {
        ...state,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          modifyStatus: STATUS.UPDATED,
        },
      };
    case ACTIONS.REQUEST_DELETE_HIGHER_ED_ERROR:
      return {
        ...state,
        error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        higherEdsStatus: {
          ...state.higherEdsStatus,
          modifyStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };

    // GET Pers Info
    case ACTIONS.REQUEST_PERS_INFORMATION:
      return {
        ...state,
        persInfoStatus: {
          ...state.persInfoStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
      };
    case ACTIONS.RECEIVE_PERS_INFORMATION:
      return {
        ...state,
        information: action.payload,
        persInfoStatus: {
          ...state.persInfoStatus,
          getStatus: STATUS.FETCHED,
        },
      };
    case ACTIONS.RECEIVE_PERS_INFORMATION_ERROR:
      return {
        ...state,
        error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        persInfoStatus: {
          ...state.persInfoStatus,
          getStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };
    case ACTIONS.CLEAR_HIGHER_ED_MODIFY_STATUS:
      return {
        ...state,
        persInfoStatus: {
          ...state.persInfoStatus,
          modifyStatus: STATUS.UNFETCHED,
        },
      };

    //get esignable colleges
    // GET Higher Ed
    case ACTIONS.REQUEST_ESIGN_HIGHER_ED:
      return {
        ...state,
        esignHigherEdsStatus: {
          ...state.esignHigherEdsStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
        esignHigherEds: null,
      };
    case ACTIONS.RECEIVE_ESIGN_HIGHER_ED:
      return {
        ...state,
        esignHigherEds: action.esignHigherEds,
        esignHigherEdsStatus: {
          ...state.esignHigherEdsStatus,
          getStatus: STATUS.FETCHED,
        },
      };
    case ACTIONS.REQUEST_ESIGN_HIGHER_ED_ERROR:
      return {
        ...state,
        error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        esignHigherEdsStatus: {
          ...state.esignHigherEdsStatus,
          getStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };
    case ACTIONS.CLEAR_ESIGN_HIGHER_ED_GET_STATUS:
      return {
        ...state,
        esignHigherEdsStatus: {
          ...state.esignHigherEdsStatus,
          getStatus: STATUS.UNFETCHED,
          errorData: null,
        },
      };
    case ACTIONS.SET_HIGHER_ED_ORG_ADDRESS: {
      const { organizationId, orgAddressResponse } = action;
      return {
        ...state,
        orgAddresses: {
          ...state.orgAddresses,
          [organizationId]: orgAddressResponse,
        },
      };
    }
    default:
      return state;
  }
}
export default higherEds;
